export enum CrusadeHonourSources {
   Rank = 0,
   Battle = 1,
}
